import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Chart } from 'chart.js/auto'

@Component({
  selector: 'app-why-postex',
  templateUrl: './why-postex.component.html',
  styleUrls: ['./why-postex.component.scss']
})
export class WhyPostexComponent implements OnInit, OnDestroy {

  // <block:setup:1>
  DATA_COUNT = 5;
  NUMBER_CFG = { count: this.DATA_COUNT, min: 0, max: 100 };

  pieChartData = {
    labels: ['PostEx', 'Others', 'Others', 'Others', 'Others', 'Group B Nay', 'Group C Yay', 'Group C Nay'],
    datasets: [
      {
        fill: false,
        borderColor: "#121920",
        borderWidth: 4,
        backgroundColor: ["#00df9a", '#3aacff', '#ed589d', '#b851be'],
        data: [75, 16, 7, 4]
      },
      // {
      //   borderColor: "#121920",
      //   borderWidth:0,
      //   backgroundColor: ["#00df9a",'#3aacff','#ed589d','#b851be','#0f1316'],
      //   data: [40, 20,20,10,10],
      // },
      // {
      //   borderColor: "#121920",
      //   borderWidth:0,
      //   backgroundColor: ["#00df9a",'#3aacff','#ed589d','#b851be'],
      //   data: [40,20,20,20]
      // },
      // {
      //   borderColor: "#121920",
      //   borderWidth:0,
      //   backgroundColor: ['#0f1316'],
      //   data: [10],
      //   width:"10px"

      // }
    ]
  };

  areaChartData = {
    labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',''],
    datasets: [
      {
        label: 'Transaction',
        fill: true,
        borderColor: "#121920",
        borderWidth: 0,
        backgroundColor: "#00df9a",
        data: []
      },
    ]
  };
  // </block:setup>

  // <block:config:0>
  pieConfig: any = {
    type: 'doughnut',
    data: this.pieChartData,
    options: {
      cutout: 50,
      hoverOffset: 30,
      layout: {
        padding: 10,
      },
      zoomOutPercentage: 0,
      responsive: true,
      plugins: {
        legend: {
          display: false,
          labels: {
            generateLabels: function (chart: any) {
              // Get the default label list
              const original = Chart.overrides.pie.plugins.legend.labels.generateLabels;
              const labelsOriginal = original.call(this, chart);

              // Build an array of colors used in the datasets of the chart
              let datasetColors = chart.data.datasets.map(function (e: any) {
                return e.backgroundColor;
              });
              datasetColors = datasetColors.flat();

              // Modify the color and hide state of each label
              labelsOriginal.forEach((label: any) => {
                // There are twice as many labels as there are datasets. This converts the label index into the corresponding dataset index
                label.datasetIndex = (label.index - label.index % 2) / 2;

                // The hidden state must match the dataset's hidden state
                label.hidden = !chart.isDatasetVisible(label.datasetIndex);

                // Change the color to match the dataset
                label.fillStyle = datasetColors[label.index];
              });

              return labelsOriginal;
            }
          },
          onClick: function (mouseEvent: any, legendItem: any, legend: any) {
            // toggle the visibility of the dataset from what it currently is
            legend.chart.getDatasetMeta(
              legendItem.datasetIndex
            ).hidden = legend.chart.isDatasetVisible(legendItem.datasetIndex);
            legend.chart.update();
          }
        },
        tooltip: {
          callbacks: {
            label: function (context: any) {
              const labelIndex = (context.datasetIndex * 2) + context.dataIndex;
              return context.chart.data.labels[labelIndex] + ': ' + context.formattedValue;
            }
          }
        }
      },
      scales: {
        // yAxes: [
        //   {
        //     gridLines: {
        //           lineWidth: 0
        //       }
        //   }
        // ]
      }
    },
  };

  areaChartConfig: any = {
    type: 'line',
    data: this.areaChartData,
    options: {
      animation: {
        // y: {
        //   duration: 3000,
        //   from: 500
        // }
      },
      hoverOffset: 30,
      layout: {
        padding: 10,
      },
      zoomOutPercentage: 0,
      responsive: true,
      plugins: {
        legend: {
          display: false,
          labels: {
            generateLabels: function (chart: any) {
              // Get the default label list
              const original = Chart.overrides.pie.plugins.legend.labels.generateLabels;
              const labelsOriginal = original.call(this, chart);

              // Build an array of colors used in the datasets of the chart
              let datasetColors = chart.data.datasets.map(function (e: any) {
                return e.backgroundColor;
              });
              datasetColors = datasetColors.flat();

              // Modify the color and hide state of each label
              labelsOriginal.forEach((label: any) => {
                // There are twice as many labels as there are datasets. This converts the label index into the corresponding dataset index
                label.datasetIndex = (label.index - label.index % 2) / 2;

                // The hidden state must match the dataset's hidden state
                label.hidden = !chart.isDatasetVisible(label.datasetIndex);

                // Change the color to match the dataset
                label.fillStyle = datasetColors[label.index];
              });

              return labelsOriginal;
            }
          },
          onClick: function (mouseEvent: any, legendItem: any, legend: any) {
            // toggle the visibility of the dataset from what it currently is
            legend.chart.getDatasetMeta(
              legendItem.datasetIndex
            ).hidden = legend.chart.isDatasetVisible(legendItem.datasetIndex);
            legend.chart.update();
          }
        },
        tooltip: {
          enabled: false,

          callbacks: {
            label: function (context: any) {
              const labelIndex = (context.datasetIndex * 2) + context.dataIndex;
              return context.chart.data.labels[labelIndex] + ': ' + context.formattedValue;
            }
          }
        },
        elements: {
          point: {
            radius: 0
          }
        },
      },
      scales: {
        x: {
          display: false
        },
        y: {
          display: false
        }
      }
    },
  };

  pieChartCtx: any;
  areaChartCtx: any;
  showAreaChart: boolean = false;

  constructor() { }


  ngOnInit(): void {
    var div: any = document.getElementById("pie-chart")
    var ctx = div?.getContext("2d");
    if (div) {
      this.pieChartCtx = new Chart(ctx, this.pieConfig);
    } else {
      console.log("data", div);
    }
  }

  configChart() {
    var data = [
      
      0,   
      4000000000,
      5000000000,
      4500000000,
      6100000000,
      5800000000,
      3500000000,
      5000000000,
      5400000000,
      6000000000,
      4200000000,
      4500000000,
      6300000000,
      7000000000,
      5500000000,
      8100000000,
      8300000000,
      9000000000,
      10000000000,
      12000000000,
    ]



      .reverse();
    var div: any = document.getElementById("line-chart")
    var ctx = div?.getContext("2d");
    if (div) {
      this.areaChartCtx = new Chart(ctx, this.areaChartConfig);
      const interval = setInterval(() => {
        this.areaChartCtx.data.datasets[0].data[20 - data.length] = data.pop();
        this.areaChartCtx.update();
        if (data.length == 0) {
          clearInterval(interval);
        }
      }, 40);
    }

  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    var divTop: any = document.getElementById('whyPostex');
    var winHeight = window.innerHeight;

    if (divTop.getBoundingClientRect().top <= winHeight) {
      //Div is visible in window
      if (this.showAreaChart == false) {
        this.showAreaChart = true;
        setTimeout(() => this.configChart(), 100)
      }
      //Fade in Chart
    }
  }

  ngOnDestroy(): void {
    document.getElementById("whyPostex")?.remove();
  }

}

